import { render } from "./IconMenuManegmentListComponent.vue?vue&type=template&id=ff864398&scoped=true&ts=true"
import script from "./IconMenuManegmentListComponent.vue?vue&type=script&lang=ts"
export * from "./IconMenuManegmentListComponent.vue?vue&type=script&lang=ts"

import "./IconMenuManegmentListComponent.vue?vue&type=style&index=0&id=ff864398&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff864398"]])

export default __exports__